import zipcodes from 'zipcodes';

export const zipCodeConvert = (zipCode: string): [number, number] => {
    const location = zipcodes.lookup(zipCode);
    
    if (!location) {
        throw new Error(`Invalid ZIP code: ${zipCode}`);
    }

    return [location.latitude, location.longitude];
};
